module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.$user.isAdminOrCoordinator) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Assigned Coordinator")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "coordinator_id",
      "disabled": _vm.jobIsNotEditable,
      "options": _vm.coordinatorOptions
    },
    model: {
      value: (_vm.coordinator),
      callback: function($$v) {
        _vm.coordinator = $$v
      },
      expression: "coordinator"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Total Coordinator Commission")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static",
    class: {
      'text-success': _vm.coordinatorCommissionIsProfitable, 'text-danger': _vm.coordinatorCommissionIsNotProfitable
    }
  }, [_vm._v("\n              " + _vm._s(_vm.coordinatorCommissionAsMoney) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('public_quantity')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Public Job Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicQuantity),
      expression: "publicQuantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": "",
      "name": "public_quantity"
    },
    domProps: {
      "value": (_vm.publicQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.publicQuantity = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("/tonne")])])])]), _vm._v(" "), (_vm.jobIsCompleted) ? _c('div', {
    staticClass: "col-lg-3 col-lg-offset-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Total Job Commission")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static text-success"
  }, [_vm._v(_vm._s(_vm.jobCommissionAsMoney))])])])]) : _vm._e()])]), _vm._v(" "), (_vm.jobIsEditable) ? _c('div', {
    staticClass: "ibox-footer"
  }, [(_vm.canCompleteJob) ? _c('ladda-button', {
    staticClass: "btn btn-sm btn-primary job-complete",
    attrs: {
      "on-click": _vm.handleCompleteJob
    }
  }, [_vm._v("Job Complete")]) : _vm._e(), _vm._v(" "), (_vm.$user.isAdminOrCoordinator) ? _c('ladda-button', {
    staticClass: "btn btn-sm btn-success pull-right",
    attrs: {
      "on-click": _vm.handleSaveJobSetup
    }
  }, [_vm._v("Save")]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Job Setup")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-44bf6d47"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobSetup.vue
// module id = 980
// module chunks = 0